import { Link, Paragraph } from '@vimeo/iris/typography';

export default function JobMarketplace() {
  return (
    <div>
      <Paragraph size="2">
        The <em>For Hire Marketplace</em> provides a forum for Vimeo members to post job
        opportunities and find work in the video field. For more information, see our{' '}
        <Link
          variant="minimal"
          href="https://help.vimeo.com/hc/en-us/articles/12425733472273-For-Hire-Marketplace"
        >
          Help Center
        </Link>
        .
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
